import { addDays, subDays } from 'date-fns';
import { appConfig } from 'brand-config';

import { awsDateFormatter, awsDateToJs } from './formatters';

/**
 * Per-brand toggle for displaying the policy EXPIRATION/anniversary date instead of the stored
 * endDate ("Last Full Day Of Coverage"). Branch stores endDate = expiration − 1 day; some brands
 * (e.g. Forreston, matching the legacy IMT presentation) want staff-fe to show/edit the expiration
 * date. The stored value is unchanged — only display + edit round-trip shift by a day. (#32070)
 */
export const showExpirationInsteadOfEndDate = () =>
  appConfig?.featureFlags?.showExpirationDateInsteadOfEndDate ?? false;

/** Stored endDate (last full day of coverage) → displayed expiration/anniversary date (+1 day). */
export const endDateToExpirationDisplay = (awsEndDate) =>
  awsEndDate ? awsDateFormatter(addDays(awsDateToJs(awsEndDate), 1)) : awsEndDate;

/** Displayed expiration date → stored endDate (−1 day). Inverse of endDateToExpirationDisplay. */
export const expirationDisplayToEndDate = (awsExpirationDate) =>
  awsExpirationDate ? awsDateFormatter(subDays(awsDateToJs(awsExpirationDate), 1)) : awsExpirationDate;
